import { Alert, Box, DialogTitle, styled, Typography } from '@mui/material';

export const PublishMessageContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 600px;
`;

export const PublishMessageText = styled(Typography)(
  ({ theme, colorType }) => `
    font-size: 16px;
    font-weight: 500;
    color: ${
      colorType === 'info'
        ? theme.palette.info.main
        : theme.palette.success.main
    };
    `,
);

export const PublishMessageLink = styled(Typography)(
  ({ theme, colorType }) => `
    font-size: 13px;
    font-weight: 500;
    color: ${
      colorType === 'info'
        ? theme.palette.info.main
        : theme.palette.success.main
    };
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: ${
      colorType === 'info'
        ? theme.palette.info.main
        : theme.palette.success.main
    };
  `,
);

export const PublicationModalTitle = styled(DialogTitle)`
  width: 100%;
  padding: 16px 20px 16px 24px;
  font-family: Roboto;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0;
`;

export const PublicationModalContent = styled(Box)`
  width: 100%;
  margin: -16px;
  padding: 8px 24px 24px 24px;
`;

export const PublicationWarningAlert = styled(Alert)(({ theme }) => ({
  width: 552,
  minHeight: 44,
  padding: 4,
  borderRadius: 4,
  '& .MuiAlert-icon': {
    color: theme.palette.info.dark,
    marginLeft: 4,
  },
}));
